module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba-funabashi-point2-2@3x-9d30e54af139acbebfa1efd87406b712.webp";